<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Test Configurations</a></li>
          <li><a>QP Ranges</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">QP Ranges</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by Qp ranges, species type"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <!--qp range block-->
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let qprange of qpRangesList let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ qprange && qprange?.qp?.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span>Culture Category: </span>
                  <span>{{qprange && qprange.cultureCategory.name}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Species Type: </span>
                  <span class="description">{{qprange && qprange.speciesType?.name}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Max: </span>
                  <span class="description">{{qprange && qprange?.max_acc_range}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Min: </span>
                  <span class="description">{{qprange && qprange?.min_acc_range}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ qprange?.updatedAt | date: 'dd MMM yyyy'}}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Business Type" (click)="getQPRangeById(qprange.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">QP Ranges Not Found</div>
        <!--qp range block end-->
      </div>
      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
        <!--outside close-->
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">QP Range</div>
                <button class="add-update-submit-button" (click)="addQPRange()" [disabled]="QpRangesDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Query Param</mat-label>
                  <mat-select id="queryparam" formControlName="qp_id">
                    <mat-option value="" disabled>Select Query Param</mat-option>
                    <mat-option *ngFor="let category of queryParams" [value]="category.id"> {{ category.name }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.qp_id.invalid"><i>Select query param</i></mat-hint>
                  <mat-hint *ngIf="f.qp_id.valid"><i>Query param selected</i></mat-hint>
                  <mat-error *ngIf="(f.qp_id.touched || f.qp_id.dirty || submitted) && f.qp_id.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Culture Category</mat-label>
                  <mat-select id="culturecategory" formControlName="culture_category_id" (selectionChange)="getSpeciesTypeByCultureCategoryId($event)">
                    <mat-option value="" disabled>Select Culture Category</mat-option>
                    <mat-option *ngFor="let category of cultureCategories" [value]="category.id"> {{ category.name }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.culture_category_id.invalid"><i>Select culture category</i></mat-hint>
                  <mat-hint *ngIf="f.culture_category_id.valid"><i>Culture category selected</i></mat-hint>
                  <mat-error *ngIf="(f.culture_category_id.touched || f.culture_category_id.dirty || submitted) && f.culture_category_id.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Species Type</mat-label>
                  <mat-select id="species" formControlName="species_type_id">
                    <mat-option value="" disabled>Select Species Type</mat-option>
                    <mat-option *ngFor="let category of speciesTypes" [value]="category.id"> {{ category.name }} </mat-option>
                  </mat-select>
                  <mat-hint *ngIf="f.species_type_id.invalid"><i>Select species type</i></mat-hint>
                  <mat-hint *ngIf="f.species_type_id.valid"><i>Species type selected</i></mat-hint>
                  <mat-error *ngIf="(f.species_type_id.touched || f.species_type_id.dirty || submitted) && f.species_type_id.hasError('required')">
                    <i>Required.</i>
                  </mat-error>
                </mat-form-field>
                <h4 class="accrange">Acceptable Range:</h4>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Min</mat-label>
                  <input matInput id="min" type="text" autocomplete="off" formControlName="min_acc_range" placeholder="Enter min"/>
                  <mat-hint><i>Only numbers</i></mat-hint>
                  <mat-error *ngIf="(f.min_acc_range.touched || f.min_acc_range.dirty || submitted) && f.min_acc_range.errors">
                    <i> {{ f.min_acc_range.hasError('required') ? 'Required.' : f.min_acc_range.hasError('pattern') ? 'Only numeric values are allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Max</mat-label>
                  <input matInput id="max" type="text" autocomplete="off" formControlName="max_acc_range" placeholder="Enter max"/>
                  <mat-hint><i>Only numbers</i></mat-hint>
                  <mat-error *ngIf="(f.max_acc_range.touched || f.max_acc_range.dirty || submitted) && f.max_acc_range.errors">
                    <i> {{ f.max_acc_range.hasError('required') ? 'Required.' : f.max_acc_range.hasError('pattern') ? 'Only numeric values are allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>
